import type { RegionScreenToggleEntity } from './RegionScreenToggleEntity'

export class RegionMenuSettingEntity {
  regionId?: number
  regionName?: string | null
  screens?: RegionScreenToggleEntity[] | null
}
